import type { ElementType, ReactNode } from 'react';
import { clsx } from 'clsx';

interface EmptyStateProps {
  icon: ElementType;
  title: string;
  description: string;
  /** Optionaler Zusatz-Hinweis zwischen Beschreibung und Action (z. B. Info-Box). */
  hint?: ReactNode;
  action?: {
    label: string;
    href?: string;
    onClick?: () => void;
  };
  className?: string;
}

export function EmptyState({
  icon: Icon,
  title,
  description,
  hint,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={clsx(
        'flex flex-col items-center justify-center text-center py-12 px-6',
        className,
      )}
    >
      <div className="mx-auto w-14 h-14 bg-zinc-50 border border-zinc-100 rounded-full flex items-center justify-center mb-4">
        <Icon size={28} className="text-zinc-300" />
      </div>
      <h3 className="text-secondary font-bold text-lg mb-2">{title}</h3>
      <p className="text-zinc-500 text-sm max-w-sm mx-auto leading-relaxed">
        {description}
      </p>
      {hint}
      {action && (
        action.href ? (
          <a
            href={action.href}
            className="mt-4 inline-flex items-center gap-2 px-4 py-2 bg-primary text-white text-sm font-bold rounded-lg hover:bg-primary-hover transition-colors"
          >
            {action.label}
          </a>
        ) : (
          <button
            onClick={action.onClick}
            type="button"
            className="mt-4 inline-flex items-center gap-2 px-4 py-2 bg-primary text-white text-sm font-bold rounded-lg hover:bg-primary-hover transition-colors"
          >
            {action.label}
          </button>
        )
      )}
    </div>
  );
}
